export const emptyMainUrls = {
  APIManager: '',
  EntityManager: '',
  MainState: '',
  Utils: '',
  Icons: '',
  UIKit: '',
  Maps: '',
  AuraComponents: '',
  FeatureCore: ''
}
